/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { FetchError, FetchSuccess, fetchBase } from "./managers";
import { GetTripsResponse } from "./tripsApiTypes";

export const getTrips = async (eventId?: string) => {
  try {
    const res = await fetchBase(`user-dashboard/dashboard`, null, {
      slugTarget: "url",
      eventId,
    });

    return new FetchSuccess<GetTripsResponse>(res);
  } catch (res) {
    throw new FetchError(res as Response);
  }
};

export const getReservation = async (id: any, eventId?: string) => {
  try {
    const res = await fetchBase(`user-dashboard/get-reservation/${id}`, null, {
      slugTarget: "url",
      eventId,
    });

    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res as Response);
  }
};

export const createReservation = async (body: any, eventId?: string) => {
  try {
    const res = await fetchBase(
      `user-dashboard/create-reservation`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
      {
        slugTarget: "url",
        eventId,
      },
    );

    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res as Response);
  }
};

export const updateReservation = async (
  id: any,
  body: any,
  eventId?: string,
) => {
  try {
    const res = await fetchBase(
      `user-dashboard/update-reservation/${id}`,
      {
        method: "PATCH",
        body: JSON.stringify(body),
      },
      {
        slugTarget: "url",
        eventId,
      },
    );

    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res as Response);
  }
};

export const createFlight = async (body: any, eventId?: string) => {
  try {
    const res = await fetchBase(
      `user-dashboard/flights`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
      {
        slugTarget: "url",
        eventId,
      },
    );

    return new FetchSuccess(res, "Flight created successfully");
  } catch (res) {
    throw new FetchError(res as Response);
  }
};

export const updateFlight = async (id: any, body: any, eventId?: string) => {
  try {
    const res = await fetchBase(
      `user-dashboard/flights/${id}`,
      {
        method: "PATCH",
        body: JSON.stringify(body),
      },
      {
        slugTarget: "url",
        eventId,
      },
    );

    return new FetchSuccess(res, "Flight updated successfully");
  } catch (res) {
    throw new FetchError(res as Response, "Failed to update flight");
  }
};
